"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * ServiceNow AI Toolkit
 * ServiceNow AI Toolkit API
 *
 * The version of the OpenAPI document:
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobRunApi = exports.JobRunApiFactory = exports.JobRunApiFp = exports.JobRunApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * JobRunApi - axios parameter creator
 * @export
 */
const JobRunApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get runs of jobs in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountJobRunGet: (accountId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1) => __awaiter(this, [accountId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1], void 0, function* (accountId, limit, offset, order, permission, q, human, recursive, options = {}) {
            // verify required parameter 'accountId' is not null or undefined
            (0, common_1.assertParamExists)('v1AccountJobRunGet', 'accountId', accountId);
            const localVarPath = `/v1/account/{account_id}/job_run`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            if (recursive !== undefined) {
                localVarQueryParameter['recursive'] = recursive;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get runs of jobs in the cluster
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ClusterJobRunGet: (limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1) => __awaiter(this, [limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1], void 0, function* (limit, offset, order, permission, q, human, options = {}) {
            const localVarPath = `/v1/cluster/job_run`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get runs of jobs created by your user/role
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MeJobRunGet: (limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1) => __awaiter(this, [limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1], void 0, function* (limit, offset, order, permission, q, human, options = {}) {
            const localVarPath = `/v1/me/job_run`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get runs of jobs in the organization
         * @param {string} organizationId The ID or fullname of the organization
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationJobRunGet: (organizationId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1) => __awaiter(this, [organizationId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1], void 0, function* (organizationId, limit, offset, order, permission, q, human, options = {}) {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('v1OrganizationJobRunGet', 'organizationId', organizationId);
            const localVarPath = `/v1/organization/{organization_id}/job_run`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get runs of jobs created by the role
         * @param {string} roleId The ID or fullname of the role
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleJobRunGet: (roleId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1) => __awaiter(this, [roleId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1], void 0, function* (roleId, limit, offset, order, permission, q, human, options = {}) {
            // verify required parameter 'roleId' is not null or undefined
            (0, common_1.assertParamExists)('v1RoleJobRunGet', 'roleId', roleId);
            const localVarPath = `/v1/role/{role_id}/job_run`
                .replace(`{${"role_id"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get runs of jobs created by the service
         * @param {string} serviceId The ID or fullname of the service
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ServiceJobRunGet: (serviceId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1) => __awaiter(this, [serviceId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1], void 0, function* (serviceId, limit, offset, order, permission, q, human, options = {}) {
            // verify required parameter 'serviceId' is not null or undefined
            (0, common_1.assertParamExists)('v1ServiceJobRunGet', 'serviceId', serviceId);
            const localVarPath = `/v1/service/{service_id}/job_run`
                .replace(`{${"service_id"}}`, encodeURIComponent(String(serviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get runs of jobs in your account
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShorcutJobRunGet: (limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1) => __awaiter(this, [limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1], void 0, function* (limit, offset, order, permission, q, human, recursive, options = {}) {
            const localVarPath = `/v1/job_run`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            if (recursive !== undefined) {
                localVarQueryParameter['recursive'] = recursive;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get runs of jobs created by the user
         * @param {string} userId The ID or fullname of the user
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserJobRunGet: (userId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1) => __awaiter(this, [userId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1], void 0, function* (userId, limit, offset, order, permission, q, human, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('v1UserJobRunGet', 'userId', userId);
            const localVarPath = `/v1/user/{user_id}/job_run`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.JobRunApiAxiosParamCreator = JobRunApiAxiosParamCreator;
/**
 * JobRunApi - functional programming interface
 * @export
 */
const JobRunApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.JobRunApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Get runs of jobs in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountJobRunGet(accountId, limit, offset, order, permission, q, human, recursive, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AccountJobRunGet(accountId, limit, offset, order, permission, q, human, recursive, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['JobRunApi.v1AccountJobRunGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get runs of jobs in the cluster
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ClusterJobRunGet(limit, offset, order, permission, q, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ClusterJobRunGet(limit, offset, order, permission, q, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['JobRunApi.v1ClusterJobRunGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get runs of jobs created by your user/role
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MeJobRunGet(limit, offset, order, permission, q, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1MeJobRunGet(limit, offset, order, permission, q, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['JobRunApi.v1MeJobRunGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get runs of jobs in the organization
         * @param {string} organizationId The ID or fullname of the organization
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationJobRunGet(organizationId, limit, offset, order, permission, q, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1OrganizationJobRunGet(organizationId, limit, offset, order, permission, q, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['JobRunApi.v1OrganizationJobRunGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get runs of jobs created by the role
         * @param {string} roleId The ID or fullname of the role
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleJobRunGet(roleId, limit, offset, order, permission, q, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1RoleJobRunGet(roleId, limit, offset, order, permission, q, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['JobRunApi.v1RoleJobRunGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get runs of jobs created by the service
         * @param {string} serviceId The ID or fullname of the service
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ServiceJobRunGet(serviceId, limit, offset, order, permission, q, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ServiceJobRunGet(serviceId, limit, offset, order, permission, q, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['JobRunApi.v1ServiceJobRunGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get runs of jobs in your account
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShorcutJobRunGet(limit, offset, order, permission, q, human, recursive, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ShorcutJobRunGet(limit, offset, order, permission, q, human, recursive, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['JobRunApi.v1ShorcutJobRunGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get runs of jobs created by the user
         * @param {string} userId The ID or fullname of the user
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserJobRunGet(userId, limit, offset, order, permission, q, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1UserJobRunGet(userId, limit, offset, order, permission, q, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['JobRunApi.v1UserJobRunGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.JobRunApiFp = JobRunApiFp;
/**
 * JobRunApi - factory interface
 * @export
 */
const JobRunApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.JobRunApiFp)(configuration);
    return {
        /**
         *
         * @summary Get runs of jobs in the account
         * @param {JobRunApiV1AccountJobRunGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountJobRunGet(requestParameters, options) {
            return localVarFp.v1AccountJobRunGet(requestParameters.accountId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get runs of jobs in the cluster
         * @param {JobRunApiV1ClusterJobRunGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ClusterJobRunGet(requestParameters = {}, options) {
            return localVarFp.v1ClusterJobRunGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get runs of jobs created by your user/role
         * @param {JobRunApiV1MeJobRunGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MeJobRunGet(requestParameters = {}, options) {
            return localVarFp.v1MeJobRunGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get runs of jobs in the organization
         * @param {JobRunApiV1OrganizationJobRunGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationJobRunGet(requestParameters, options) {
            return localVarFp.v1OrganizationJobRunGet(requestParameters.organizationId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get runs of jobs created by the role
         * @param {JobRunApiV1RoleJobRunGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleJobRunGet(requestParameters, options) {
            return localVarFp.v1RoleJobRunGet(requestParameters.roleId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get runs of jobs created by the service
         * @param {JobRunApiV1ServiceJobRunGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ServiceJobRunGet(requestParameters, options) {
            return localVarFp.v1ServiceJobRunGet(requestParameters.serviceId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get runs of jobs in your account
         * @param {JobRunApiV1ShorcutJobRunGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShorcutJobRunGet(requestParameters = {}, options) {
            return localVarFp.v1ShorcutJobRunGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get runs of jobs created by the user
         * @param {JobRunApiV1UserJobRunGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserJobRunGet(requestParameters, options) {
            return localVarFp.v1UserJobRunGet(requestParameters.userId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(axios, basePath));
        },
    };
};
exports.JobRunApiFactory = JobRunApiFactory;
/**
 * JobRunApi - object-oriented interface
 * @export
 * @class JobRunApi
 * @extends {BaseAPI}
 */
class JobRunApi extends base_1.BaseAPI {
    /**
     *
     * @summary Get runs of jobs in the account
     * @param {JobRunApiV1AccountJobRunGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobRunApi
     */
    v1AccountJobRunGet(requestParameters, options) {
        return (0, exports.JobRunApiFp)(this.configuration).v1AccountJobRunGet(requestParameters.accountId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get runs of jobs in the cluster
     * @param {JobRunApiV1ClusterJobRunGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobRunApi
     */
    v1ClusterJobRunGet(requestParameters = {}, options) {
        return (0, exports.JobRunApiFp)(this.configuration).v1ClusterJobRunGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get runs of jobs created by your user/role
     * @param {JobRunApiV1MeJobRunGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobRunApi
     */
    v1MeJobRunGet(requestParameters = {}, options) {
        return (0, exports.JobRunApiFp)(this.configuration).v1MeJobRunGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get runs of jobs in the organization
     * @param {JobRunApiV1OrganizationJobRunGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobRunApi
     */
    v1OrganizationJobRunGet(requestParameters, options) {
        return (0, exports.JobRunApiFp)(this.configuration).v1OrganizationJobRunGet(requestParameters.organizationId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get runs of jobs created by the role
     * @param {JobRunApiV1RoleJobRunGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobRunApi
     */
    v1RoleJobRunGet(requestParameters, options) {
        return (0, exports.JobRunApiFp)(this.configuration).v1RoleJobRunGet(requestParameters.roleId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get runs of jobs created by the service
     * @param {JobRunApiV1ServiceJobRunGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobRunApi
     */
    v1ServiceJobRunGet(requestParameters, options) {
        return (0, exports.JobRunApiFp)(this.configuration).v1ServiceJobRunGet(requestParameters.serviceId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get runs of jobs in your account
     * @param {JobRunApiV1ShorcutJobRunGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobRunApi
     */
    v1ShorcutJobRunGet(requestParameters = {}, options) {
        return (0, exports.JobRunApiFp)(this.configuration).v1ShorcutJobRunGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get runs of jobs created by the user
     * @param {JobRunApiV1UserJobRunGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobRunApi
     */
    v1UserJobRunGet(requestParameters, options) {
        return (0, exports.JobRunApiFp)(this.configuration).v1UserJobRunGet(requestParameters.userId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.JobRunApi = JobRunApi;
